import { Wifi, WifiOff } from 'lucide-react';

export function OfflineBanner() {
  return (
    <div className="bg-yellow-50 p-4 rounded-md mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <WifiOff className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">
            You are offline
          </h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>
              Some features may be limited, but you can still view cached data. Changes will sync when you're back online.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}